import ApiService from "service/Api";
import { BannerPayloadTypes } from "utilities/types/Banner";

const BannerService = {
  getAllBanners: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/banners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeBanner: async (payload: BannerPayloadTypes) => {
    const {
      desktopBannerImage,
      mobileBannerImage,
      location,
      redirectUrl,
      sortOrder,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        desktop_banner_image: desktopBannerImage,
        mobile_banner_image: mobileBannerImage,
        location: location,
        redirect_url: redirectUrl,
        sort_order: sortOrder,
      },
      url: "/admin/banners",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateBanner: async (bannerId: string, payload: BannerPayloadTypes) => {
    const {
      desktopBannerImage,
      mobileBannerImage,
      location,
      redirectUrl,
      sortOrder,
    } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        banner_image: desktopBannerImage,
        mobile_banner_image: mobileBannerImage,
        location: location,
        redirect_url: redirectUrl,
        sort_order: sortOrder,
        _method: "PUT",
      },
      url: "/admin/banners/" + bannerId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteBanner: async (bannerId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/banners/" + bannerId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default BannerService;
